import { render, staticRenderFns } from "./purchase-orders-forecast.vue?vue&type=template&id=dc9e5dce&scoped=true&"
import script from "./purchase-orders-forecast.vue?vue&type=script&lang=js&"
export * from "./purchase-orders-forecast.vue?vue&type=script&lang=js&"
import style0 from "./purchase-orders-forecast.vue?vue&type=style&index=0&id=dc9e5dce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9e5dce",
  null
  
)

export default component.exports